import React from 'react';
import {Toast, Icon} from 'antd-mobile';
import postData from '../../assets/xhr';
import model from '../../assets/model';

class ImageItem extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            base64: null,
            file: props.file,
            upload: 0
        }
    }
    componentWillMount(){
        let file = this.state.file;
        let fileReader = new FileReader();
        let that = this;
        fileReader.onload = function(){
            that.setState({
                base64: this.result
            });
        }
        fileReader.readAsDataURL(file);
        this.xhr = this.uploadFile();
    }
    uploadFile =()=>{
        let file = this.state.file;
        let props = this.props;
        if (file.uploading > 0){
            return;
        }
        // 上传图片
        let formData = new FormData();
        formData.append('fileData', file);
        formData.append('cardId', model.cardId);
        file.uploading = 1;  // 上传中
        this.setState({
            upload: 1
        })
        props.upload && props.upload(props.index, file);
        let xhr = postData({
            url: '/smartform/rest/extApi/data/file/upload',
            data: formData,
            form: true,
            callback: (res)=>{
                let {code, message, data} = res;
                if (code === 0){
                    file.uploading = 2; // 上传成功
                    this.setState({
                        upload: 2
                    })
                    file.tempPath = data.filePath;
                    file.base64 = this.state.base64;
                }else{
                    Toast.info(message, 1.5);
                    file.uploading = 3; //上传失败
                    this.setState({
                        upload: 3
                    })
                }
            },
            error: ()=>{
                Toast.info($st('上传失败'), 1.5);
                file.uploading = 3; //上传失败
                this.setState({
                    upload: 3
                })
            }
        });
        xhr.onprogress = (data)=>{
        }
        xhr.onload = (data)=>{
        }
    }
    onDelete =()=>{
        let onDelete = this.props.delete;
        onDelete && onDelete();
        // 取消上传
        let xhr = this.xhr;
        xhr && xhr.abort();
    }
    onReload=()=>{
        let file = this.props.file;
        file.uploading = 0;
        this.setState({
            upload: 0
        });
        this.uploadFile();
    }
    componentWillUnmount(){
        let xhr = this.xhr;
        xhr && xhr.abort &&xhr.abort();
    }
    render(){
        let base64 = this.state.base64;
        let state = this.state;
        let style = {
            backgroundImage: `url(${base64})`
        }
        return (
            <div className="image-item" style={base64 && style}>
                <div className="btn-del" onClick={this.onDelete}>
                    <Icon type="cross" size="sm"></Icon>
                </div>
                {state.upload === 1 && <Icon type='loading' className="image-loading"></Icon>}
                {state.upload === 3 && <div className="reload-wrapper"  onClick={this.onReload}><span className='file-reload'>{$st("重传")}</span></div>}
            </div>
        )
    }
}
export default ImageItem;



// WEBPACK FOOTER //
// ./src/component/Image/ImageItem.js